import script from "./BottomBar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./BottomBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomBar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./BottomBar.vue?vue&type=script&setup=true&lang=ts"

import "./BottomBar.vue.scss?vue&type=style&index=0&id=150d78c5&lang=scss&scoped=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./BottomBar.vue?vue&type=style&index=0&id=150d78c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-150d78c5"]])

export default __exports__